<template>
  <w-sliding-popup ref="mibFileSettingPopup" title="MIB 파일 설정" width="400px" @close="onClosePopup">
    <div slot="content">
      <el-row class="title-bar" type="flex" justify="start">
        <div class="vertical-center-box">
          <div class="setting-addel">
            <el-upload :auto-upload="false" :on-change="onClickAddButton" action="" :before-upload="(file) => file"
            :show-file-list="false" style="display: inline;">
              <el-button size="mini"><i class="fas fa-plus"></i></el-button>
            </el-upload>
            <el-button size="mini" :disabled="selectedRows.length === 0" @click="onClickDeleteButton"><i class="fas fa-minus"></i></el-button>
          </div>
        </div>
      </el-row>
      <el-table-wrapper ref="table" :data="tableData" :columns="tableColumns" :pagination="false" @selection-change="onSelectionChange">
        <template slot-scope="scope" slot="checkbox-slot">
          <el-checkbox v-model="scope.row.mibAutoLoadingFlag" true-label="1" false-label="0" @change="onChangeCheckBox(scope.row, ...arguments)" />
        </template>
      </el-table-wrapper>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isEmpty, isNil, cloneDeep } from 'lodash';
import MibAPI from '@/api/mib';
import msgUtil from '@/utils/message';

export default {
  name: 'WMibFileSettingPopup',
  data() {
    return {
      selectedRows: [],
      tableColumns: [
        {
          type: 'selection',
          headerAlign: 'center',
          align: 'center',
          width: 50,
        },
        {
          prop: 'mibFile',
          label: 'MIB 파일',
        },
        {
          prop: 'mibAutoLoadingFlag',
          label: '선택',
          scopedSlot: 'checkbox-slot',
          headerAlign: 'center',
          align: 'center',
          width: 50,
        },
      ],
      tableData: [],
      mibFileName: null,
    };
  },
  watch: {
    scheduleData() {
      this.loadData();
    },
  },
  methods: {
    open() {
      this.loadData();
      this.$refs.mibFileSettingPopup.visible = true;
    },
    onClosePopup() {
      this.$emit('close-popup', this.mibFileName);
      this.$refs.mibFileSettingPopup.visible = false;
      this.tableData = [];
    },
    loadData() {
      MibAPI.getMibList().then((response) => {
        const result = response.data;
        if (result.success) {
          this.tableData = cloneDeep(result.data);
          if (!isEmpty(this.tableData)) {
            this.mibFileName = this.tableData.filter((item) => item.mibAutoLoadingFlag === '1')[0].mibFile;
          }
        }
      }).catch(() => {});
    },
    onChangeCheckBox(row, value) {
      if (value === '0') {
        row.mibAutoLoadingFlag = '1';
      } else {
        const changeRow = this.tableData.filter((item) => item.mibFile !== row.mibFile && item.mibAutoLoadingFlag === '1')[0];
        if (!isNil(changeRow)) {
          changeRow.mibAutoLoadingFlag = '0';
        }
        MibAPI.updateMibFiles([row, changeRow]).then((response) => {
          const result = response.data;
          if (result.success) {
            this.mibFileName = row.mibFile;
            this.loadData();
            this.$message(`${row.mibFile}을 선택하였습니다.`);
          }
        }).catch(() => {
          this.$message('통신이 원할하지 않습니다.');
        });
      }
    },
    onClickAddButton(file) {
      if (file.size > 16 * 1024 * 1024) {
        this.$message('파일 사이즈가 16메가바이트를 초과하였습니다.');
      } else {
        const formParams = new FormData();
        formParams.append('fileName', file.name);
        formParams.append(file.name, file.raw);

        MibAPI.insertMibFile(formParams).then((response) => {
          const result = response.data;
          if (result.success) {
            this.loadData();
            if (result.data === '저장되었습니다.') {
              this.$message(msgUtil.getCustomResultMsgData(result.data, true));
            } else {
              this.$message(msgUtil.getCustomResultMsgData(result.data, false));
            }
          } else {
            this.$message(msgUtil.getCustomResultMsgData(result.data, false));
          }
        }).catch(() => {
          this.$message('통신이 원할하지 않습니다.');
        });
      }
    },
    onClickDeleteButton() {
      const selectedRows = this.selectedRows;
      const usingMib = selectedRows.filter((item) => item.mibAutoLoadingFlag === '1');
      if (!isEmpty(usingMib)) {
        this.$message('사용중인 MIB 파일은 삭제할 수 없습니다.');
      } else {
        MibAPI.deleteMibFiles(this.selectedRows).then((response) => {
          const result = response.data;
          if (result.success) {
            this.loadData();
            this.$message('삭제되었습니다.');
          }
        }).catch(() => {
          this.$message('통신이 원할하지 않습니다.');
        });
      }
    },
    onSelectionChange(selection) {
      this.selectedRows = selection;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/MibBrowser/popup/MibFileSettingPopup.vue